/* Domus Giulietta: formulário de candidatura (blocks/dg-candidatura.liquid, Tarefa 24).
   1) No envio, o botão diz "Enviando…" e fica aria-busy (o texto vem do data-dg-enviando do bloco).
   2) Depois do envio, o foco vai para a confirmação ou para o erro, que leitor de tela anuncia.
   3) Correção 01 do controlador: o rótulo original fica guardado em data-dg-rotulo, um segundo
      envio é ignorado enquanto o botão estiver aria-busy, e a volta pelo histórico (pageshow com
      event.persisted) devolve o rótulo — antes o botão ficava travado em "Enviando…".
   Ouvintes delegados em document: o editor re-renderiza o bloco sem recarregar a página.
   Sem módulos @theme/* do Horizon. */
(function () {
  if (window.dgCandidatura) return;
  window.dgCandidatura = true;

  function rotular(form, ocupado) {
    var acoes = form.querySelector('[data-dg-enviando]');
    var botao = acoes && acoes.querySelector('button[type="submit"]');
    if (!botao) return;
    var rotulo = botao.querySelector('span') || botao;
    if (ocupado) {
      if (!botao.hasAttribute('data-dg-rotulo')) botao.setAttribute('data-dg-rotulo', rotulo.textContent);
      rotulo.textContent = acoes.getAttribute('data-dg-enviando') || rotulo.textContent;
      botao.setAttribute('aria-busy', 'true');
      return;
    }
    if (botao.hasAttribute('data-dg-rotulo')) {
      rotulo.textContent = botao.getAttribute('data-dg-rotulo');
      botao.removeAttribute('data-dg-rotulo');
    }
    botao.removeAttribute('aria-busy');
  }

  document.addEventListener('submit', function (evento) {
    var form = evento.target;
    if (!form || !form.classList || !form.classList.contains('dg-candidatura__form')) return;
    var acoes = form.querySelector('[data-dg-enviando]');
    var botao = acoes && acoes.querySelector('button[type="submit"]');
    if (botao && botao.getAttribute('aria-busy') === 'true') {
      evento.preventDefault();
      return;
    }
    rotular(form, true);
  });

  window.addEventListener('pageshow', function (evento) {
    if (!evento.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('.dg-candidatura__form'), function (form) {
      rotular(form, false);
    });
  });

  function focar() {
    var alvo = document.querySelector('.dg-candidatura [data-dg-foco]');
    if (alvo) alvo.focus();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focar);
  } else {
    focar();
  }
})();
